<template>
    <div class="information-screen">
        <h1>{{ props.question.information }}</h1>
        <div class="question-description" v-show=props.question.description>
            <p>{{ props.question.description }}</p>
        </div>
        <button class="app-btn" @click="handleClick">Ok</button>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import { LocalStorageService } from '@/services/LocalStorageService';

const localStorageService = new LocalStorageService();

const props = defineProps(['question']);

const emit = defineEmits(['accepted']);

const handleClick = () => {
    localStorageService.updateQuestionState(props.question.id, { userConfirmed: true });

    emit('accepted');
};
</script>

<style lang="scss" scoped>
.information-screen {
    height: calc(100vh - 200px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 5%;

    @media (max-width: 600px) {
        justify-content: flex-start;
        height: auto;
        margin: 100px 0;
    }

    button {
        margin-top: 30px;
    }
}
</style>
